export default __webpack_public_path__ + "static/media/no-avatar.74b8e1c7.svg";